import { COLORS } from '@/styles/colorTheme';
import { LayoutDashboard } from 'lucide-react';

const DashboardIcon = ({ state = 'mouseup', isSelected = false }) => {
  let color = COLORS.Text400;
  if (state === 'mousedown') color = '#fff';

  return (
    <>
      <LayoutDashboard
        size={22}
        strokeWidth={1.5}
        color={color}
        fill={isSelected ? color : 'transparent'}
      />
    </>
  );
};

export default DashboardIcon;
